import Constants from '../actions/types';

const initialState = {
  dataProfiles: [],
  loading: false,
  message: null,
  severity: null,
  attributes: [],
  values: []
};

const dataProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.DATAPROFILE_GET_REQUEST: {
      const newState = {
        ...initialState,
        loading: true
      };

      return newState;
    }

    case Constants.DATAPROFILE_GET_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              dataProfiles: [],
              message: 'No data profiles were found in the system.',
              severity: 'info'
            }
          : {
              ...state,
              loading: false,
              dataProfiles: action.payload,
              message: null,
              severity: null
            };

      return newState;
    }

    case Constants.DATAPROFILE_GET_FAILURE: {
      const newState = {
        ...state,
        dataProfiles: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_GETATTR_REQUEST: {
      const newState = {
        ...state,
        loading: true
      };

      return newState;
    }

    case Constants.DATAPROFILE_GETATTR_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              attributes: [],
              message:
                'No attributes were found in the system for this data profile.',
              severity: 'info'
            }
          : {
              ...state,
              loading: false,
              attributes: action.payload,
              message: null,
              severity: null
            };

      return newState;
    }

    case Constants.DATAPROFILE_GETATTR_FAILURE: {
      const newState = {
        ...state,
        attributes: [],
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_GETATTRVAL_REQUEST: {
      const newState = {
        ...state,
        values: [],
        loading: true
      };

      return newState;
    }

    case Constants.DATAPROFILE_GETATTRVAL_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              values: [],
              message:
                'No attribute values were found in the system for this attribute.',
              severity: 'info'
            }
          : {
              ...state,
              loading: false,
              values: action.payload,
              message: null,
              severity: null
            };

      return newState;
    }

    case Constants.DATAPROFILE_GETATTRVAL_FAILURE: {
      const newState = {
        ...state,
        values: [],
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_DELETE_SUCCESS: {
      const newState = {
        ...state,
        message: 'The data profile was deleted successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_DELETE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_GENERATE_SUCCESS: {
      const newState = {
        ...state,
        message:
          'The job to generate a new data profile was started successfully.',
        severity: 'info',
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_GENERATE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };

      return newState;
    }

    case Constants.DATAPROFILE_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };

      return newState;
    }

    default: {
      return state;
    }
  }
};

export default dataProfileReducer;
